import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "campaign-list",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Review configured campaigns and event schedules.",
    domain: "campaigns",
    visual: "Table",
    purposes: ["live"],
    audiences: ["analyst"],
  },
  layout: { kind: "table", skeleton: "matrix" },
  defaultLayoutClassName: "col-span-12",
};
